const MergedStatusBlock = () => {
  return (
    <div className="custom-status-block">
      <p>Suppressed (Merged)</p>
    </div>
  );
};

export default MergedStatusBlock;
